import styled from "styled-components";

export const Container = styled.div``;

export const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  margin-top: 16px;

  .contentTitle {
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-bottom: 6px;
  }  

  .row {
    width: 100%;
    height: 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    margin-top: 6px;

    .rowText {
      display: flex;
      flex-direction: row;
      align-items: center;

      .antdSwitch {
        margin-right: 12px;
      }

      .rowTitle {
        max-width: 300px;
        font-size: 12px;
        font-weight: 600;
        line-height: 16px;
        color: ${({ theme }) => theme.colors.surface.onSurface};
      }  
    }

    .rowChange {
      display: flex;
      justify-content: flex-end;
      width: 202px;
      padding-left: 16px;
      font-weight: 600;
      line-height: 16px;
      color: ${({ theme }) => theme.colors.surface.onSurfaceVariant};
  
      .ant-select-selector, .select {
        /* height: 24px !important;
        max-height: 24px !important; */
        width: 175px;
        border-radius: 6px !important;
        border: none;
      }
    }
  }
`;
